import * as actions from '../../redux/actions';

import React, { useState } from 'react'; // Import useState

import CommonService from '../../../../services/commonService';
import HeroSection from '../../common/HeroSection/HeroSection';
import KuposHelmet from '../../../common/KuposHelmet';
import Modal from 'react-bootstrap/Modal'; // Import Bootstrap Modal
import ThemeFourTitle from '../common/ThemeFourTitle';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';
// Import your images from the assets folder
import image1 from '../../../themes/assets/santajuana/TransportesSantaJuana-Trabaja-con-nosotros-Imagen-1.webp';
import image2 from '../../../themes/assets/santajuana/TransportesSantaJuana-Trabaja-con-nosotros-Imagen-2.webp';
import image3 from '../../../themes/assets/santajuana/trabaja-connosotros-imagen.webp';
import image4 from '../../../themes/assets/santajuana/image-bus-popup.png';

const ThemeFourWorkWithUsScreen = props => {
	const [showModal, setShowModal] = useState(false);
	const [modalImage, setModalImage] = useState('');

	const operator = CommonService.getLocal('op') || props.home.operator;

	// Function to toggle modal visibility
	const toggleModal = (imageSrc) => {
		setModalImage(imageSrc);
		setShowModal(!showModal);
	};

	return (
		<div>
			<KuposHelmet />
			<HeroSection
				heroImage={getIcons('TrabajaBanner', operator)}
				height={'43vh'}
				marginTop="-18px"
				title={'Trabaja con nosotros'}
				description={'Home / Trabaja con nosotros'}
			/>
			<ThemeFourTitle title='Trabaja con nosotros' />
			<Modal show={showModal} onHide={() => setShowModal(false)}>
				<Modal.Header closeButton>
				</Modal.Header>
				<Modal.Body>
					<img src="https://live.staticflickr.com/65535/53719804552_624bcaae7e_o.png" alt="Modal_Image" style={{ width: '100%', height: 'auto' }} />
				</Modal.Body>
			</Modal>
			<div style={{ display: 'flex', justifyContent: 'center' }}>
				<img src={image1} alt="Image_1" style={{ width: '250px', height: 'auto', marginRight: '10px' }} />
				<img src={image2} alt="Image_2" style={{ width: '250px', height: 'auto', marginRight: '10px' }} />
				<img src={image3} alt="Image_3" style={{ width: '250px', height: 'auto', cursor: 'pointer' }} onClick={() => toggleModal(image3)} />
			</div>
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeFourWorkWithUsScreen);


// WEBPACK FOOTER //
// ./src/features/themes/ThemeFour/ThemeFourPages/ThemeFourWorkWithUsPage.js